import { bigQuery } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { getLocalizationContext } from '@fiverr-private/localization';

export const sendEvent = (event) => {
    const { currency, locale, referrer } = getContext();
    const { formattingLocale } = getLocalizationContext();

    bigQuery.send({
        ...event,
        group: 'user_actions',
        sub_group: 'referral_program',
        event_source: referrer,
        page: {
            name: 'referral_program_page',
            element: {
                ...event.page.element,
            },
        },
        localization: {
            experience_locale: locale,
            display_currency: currency,
            formatting_locale: formattingLocale,
        },
    });
};
